import React from "react";
import Layout from "../components/Layout";
import HomeBanner from "../components/Home/HomeBanner";
import Countries from "../components/Home/Countries";
import StrategiesMission from "../components/Home/StrategiesMission";
import RegionalData from "../components/Home/RegionalData";

function Home() {
  return (
    <Layout>
      <HomeBanner />
      <Countries />
      <StrategiesMission />
      <RegionalData />
    </Layout>
  );
}

export default Home;
